export enum ModalParentIdEnum {
	FULL_CONTENT = 'modal-content',
	BODY_CONTENT = 'modal-body-content',
}
